import { classes, style } from "typestyle";
import {
  White,
  typeCompact24Display,
  typeCompact14Regular,
  Gray100
} from "@traceair/tds";

export const greetingStyle = style({ marginTop: 12 });
export const windowStyle = style({
  width: 360,
  background: White,
  marginTop: "8vh",
  borderRadius: 24,
  padding: 12
});

export const boldBigStyle = classes(
  typeCompact24Display,
  style({
    fontWeight: 700
  })
);

export const headerStyle = style({
  padding: 12,
  backgroundColor: White
});

export const descriptionStyle = classes(
  typeCompact14Regular,
  style({ color: Gray100, marginTop: 4 })
);
